<template>
  <div v-loading="listLoading" element-loading-text="拼命加载中...">
    <!-- <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="systemTag">
            </el-breadcrumb>
        </div> -->
    <div class="filter" style="margin-top: -30px">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="长促人员库">
          <el-form
            :model="param"
            :inline="true"
            label-width="125px"
            class="formInline"
            size="mini"
          >
            <div class="slide-wrap" ref="slideWrap1">
              <el-form-item label="姓名">
                <el-input
                  v-model="param.employeeName"
                  placeholder="请输入姓名..."
                  :maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input
                  v-model="param.documentNumber"
                  placeholder="请输入身份证号..."
                  :maxlength="18"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input
                  v-model="param.phone"
                  placeholder="请输入手机号..."
                  :maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item label="人员类别">
                <el-select
                  v-model="param.personType"
                  filterable
                  placeholder="请选择..."
                  disabled
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="促销员" value="0"></el-option>
                  <el-option label="督导" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select
                  v-model="param.quitCrmStatus"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="在职" value="1"></el-option>
                  <el-option label="离职中" value="2"></el-option>
                  <el-option label="离职" value="4"></el-option>
                  <el-option label="取消离职" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="米咖注册认证状态">
                <el-select
                  v-model="param.isAuthentivayion"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未注册" value="9"></el-option>
                  <el-option label="注册会员" value="0"></el-option>
                  <el-option label="身份认证" value="1"></el-option>
                  <el-option label="实名认证" value="2"></el-option>
                  <el-option label="银行卡认证" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同类型">
                <el-select
                  v-model="param.contractTypeId"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="劳务合同" value="劳务合同"></el-option>
                  <el-option label="劳动合同" value="劳动合同"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目客户">
                <el-select
                  clearable
                  v-model="param.clientId"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in allCustomers"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="账套">
                <el-select
                  v-model="param.zhangtaoId"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in zhangTaoList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="缴保城市">
                <el-input
                  v-model="param.pensionClassCityId"
                  placeholder="请输入城市..."
                  :maxlength="30"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="所属公司">
                <el-select
                  v-model="param.qiyuesuoAccountId"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="上海明酷营销服务有限公司" value="上海明酷营销服务有限公司"></el-option>
                  <el-option label="上海明酷营销服务有限公司从化分公司" value="上海明酷营销服务有限公司从化分公司"></el-option>
                  <el-option label="上海明酷营销服务有限公司深圳分公司" value="上海明酷营销服务有限公司深圳分公司"></el-option>
                  <el-option label="上海赢迪市场营销服务有限公司" value="上海赢迪市场营销服务有限公司"></el-option>
                  <el-option label="上海翰为市场营销策划有限公司" value="上海翰为市场营销策划有限公司"></el-option>
                  <el-option label="上海明酷商务咨询有限公司" value="上海明酷商务咨询有限公司"></el-option>
                  <el-option label="普乐师(上海)数字科技股份有限公司" value="普乐师(上海)数字科技股份有限公司"></el-option>
                  <el-option label="普乐师(上海)数字科技有限公司" value="普乐师(上海)数字科技有限公司"></el-option>
                  <el-option label="上海嬴迪营销服务有限公司" value="上海嬴迪营销服务有限公司"></el-option>
                  <el-option label="上海呈智信息科技有限公司" value="上海呈智信息科技有限公司"></el-option>
                  <el-option label="上海若胜米咖信息技术有限公司" value="上海若胜米咖信息技术有限公司"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="所属公司">
                <el-select
                  v-model="param.qiyuesuoAccountId"
                  filterable
                  placeholder="请选择..."
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in companyList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="促销员ID">
                <el-input
                  v-model="param.empPk"
                  placeholder="请输入促销员ID..."
                ></el-input>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px" />
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetForm()"
                  >清空</el-button
                >
                <el-button class="search-btn" @click="submitForm()"
                  >筛选</el-button
                >
                <el-button class="search-btn" @click="exportResult()"
                  >导出</el-button
                >
                 <el-button class="search-btn" @click="searchContract()"
                  >合同发起记录查询</el-button
                >
              </el-form-item>
              <div class="floatr">
                <el-form-item>
                  <el-button
                    type="text"
                    class="slide-btn"
                    @click="toggleSlide('slideWrap1', $event)"
                    >展开筛选项</el-button
                  >
                </el-form-item>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <div class="tableBody">
        <div class="title">筛选结果</div>
        <el-table
          class="limitManagerTable table-expand"
          style="width: 100%"
          :data="tableData"
          size="small"
          border
          header-row-class-name="table-header"
        >
          <el-table-column
            fixed="left"
            width="50"
            type="index"
            label="#"
            align="center"
          ></el-table-column>
          <el-table-column
            width="100"
            prop="employeeName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            width="150"
            prop="documentNumber"
            label="身份证号"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120"
            prop="employeeNumber"
            label="员工编号"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120"
            prop="id"
            label="促销员ID"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.empPk }}
            </template>
          </el-table-column>
          <el-table-column
            width="140"
            prop="phone"
            label="手机号"
            align="center"
          ></el-table-column>
          <el-table-column
            width="100"
            prop="personType"
            label="人员类别"
            align="center"
          ></el-table-column>
          <el-table-column width="100" label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.quitCrmStatus == 1">在职</div>
              <div v-if="scope.row.quitCrmStatus == 2">离职中</div>
              <div v-if="scope.row.quitCrmStatus == 4">离职</div>
              <div v-if="scope.row.quitCrmStatus == 3">取消离职</div>
            </template>
          </el-table-column>
          <el-table-column width="100" label="米咖注册认证状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.isAuthentivayion == 9">未注册</div>
              <div v-if="scope.row.isAuthentivayion == 0">注册会员</div>
              <div v-if="scope.row.isAuthentivayion == 1">身份认证</div>
              <div v-if="scope.row.isAuthentivayion == 2">实名认证</div>
              <div v-if="scope.row.isAuthentivayion == 3">银行卡认证</div>
            </template>
          </el-table-column>
          <!-- 在职合约不在此处显示 -->
          <!-- <el-table-column
            width="100"
            prop="system"
            label="在职合约"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.heyue == 1"
                style="color: #18a7ff; cursor: pointer"
                @click="edit(scope.row)"
              >
                查看
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            width="110"
            prop="clientId"
            label="在职项目客户"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120"
            prop="pensionClassCityId"
            label="缴保城市"
            align="center"
          ></el-table-column>
          <el-table-column
            width="250"
            prop="qiyuesuoAccountId"
            label="所属公司"
            align="center"
          ></el-table-column>
          <el-table-column
            width="120"
            prop="zhangtaoId"
            label="账套"
            align="center"
          ></el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="240"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDetails(scope.row)"
                ><span style="color: #66cc33">查看详情</span>
              </el-button>
              <!-- <span class="cutLine"></span> -->
              <el-button
                type="text"
                size="small"
                @click="handleQuitCrmStatus(scope.row, 4)"
                v-if="scope.row.quitCrmStatus == 2 && webId_44Auth == 2"
                ><span style="color: #f63">确认离职</span>
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="scope.row.quitCrmStatus == 2 && webId_44Auth == 2"
                @click="handleQuitCrmStatus(scope.row, 3)"
                ><span style="color: #18a7ff">取消离职</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="formData.pageSize"
          layout="slot,sizes, total,  prev, pager, next, jumper"
          :total="formData.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="人员信息"
      class="quitDialog dialog QHR_InformationBox"
      width="1160px"
      :center="true"
      :show-close="true"
      :visible.sync="Information"
    >
      <Information v-if="Information" :itemId="itemId" />
    </el-dialog>

    <el-dialog
      :title="titleContract"
      class="quitDialog dialog Qhr_contract"
      width="1020px"
      :show-close="true"
      :visible.sync="Contract"
    >
      <Contract v-if="Contract" />
    </el-dialog>
    <contractQys ref="contractQys"></contractQys>
  </div>
</template>

<script>
import utils from "../../common/js/util.js";
import Information from "./qhr/Information.vue";
import Contract from "./qhr/Contract.vue";
import contractQys from "@/components/contractQys.vue"
export default {
  components: { Information, Contract,contractQys },
  watch: {},
  data() {
    return {
      //筛选项参数
      param: {
        employeeName: null, //姓名
        documentNumber: null, //身份证号码
        phone: null, //手机号
        personType: null, //人员类别
        quitCrmStatus: null, //状态
        isAuthentivayion: null, //米咖注册认证状态
        contractTypeId: null, //合同类型
        clientId: null, //项目客户
        pensionClassCityId: null, //缴保城市
        zhangtaoId: null, //账套
        qiyuesuoAccountId: null, //所属公司
        empPk: null, //促销员ID
      },
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      zhangTaoList: [], //账套数组
      allCustomers: [], //项目列表数组
      Information: false, //查看详情
      titleContract: "", //合同的表头
      Contract: false, //合同模态框
      tableData: [], //表单信息
      companyList: [], //公司数组
      listLoading: false,
      //查看详情绑定id
      itemId: -1,
      webId_44Auth: sessionStorage.getItem("webId_44Auth"),
    };
  },
  mounted() {
    this.getData();
    this.getTerminal();
    this.getZhangtao();
    this.getCompany();
  },
  methods: {
    //获取数据
    getData() {
      this.listLoading = true;
      console.log(this.param);
      let params = {
        employeeName: this.param.employeeName,
        documentNumber: this.param.documentNumber,
        phone: this.param.phone,
        personType: this.param.personType,
        quitCrmStatus: this.param.quitCrmStatus,
        isAuthentivayion: this.param.isAuthentivayion,
        contractTypeId: this.param.contractTypeId,
        qiyuesuoAccountId: this.param.qiyuesuoAccountId,
        clientID: this.param.clientId,
        zhangtaoId: this.param.zhangtaoId,
        pensionClassCityId: this.param.pensionClassCityId,
        empPk: this.param.empPk,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo,
      };
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/CrmQhrInfoRest/qhrLongPromotionlist",
        data: params,
      })
        .then((res) => {
          this.tableData = res.data.items;
          this.formData.total = res.data.totalItemsCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    //获取项目列表
    getTerminal() {
      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/clientDropDownList",
      })
        .then((res) => {
          this.allCustomers = res.data.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    //获取公司列表
    getCompany() {
      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/companyDownList",
      })
        .then((res) => {
          this.companyList = res.data.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    //获取账套下拉
    getZhangtao() {
      this.$http({
        method: "GET",
        url: "/rest/CrmQhrInfoRest/zhangtaoDropDownList",
      })
        .then((res) => {
          console.log(res);
          this.zhangTaoList = res.data.data;
        })
        .catch((err) => {
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    formatNum(row, column, cellValue) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },
    //提交表单（筛选功能）
    submitForm() {
      this.formData.pageNo=1
      this.getData();
    },
    //重置表单（清除筛选项）
    resetForm() {
      (this.param = {
        employeeName: null, //姓名
        documentNumber: null, //身份证号码
        phone: null, //手机号
        personType: null, //人员类别
        quitCrmStatus: null, //状态
        isAuthentivayion: null, //米咖注册认证状态
        contractTypeId: null, //合同类型
        qiyuesuoAccountId: null,
        clientId: null, //项目客户
        pensionClassCityId: null, //缴保城市
        zhangtaoId: null, //账套
        empPk: null, //促销员ID
      }),
        this.getData();
    },

    //展开收起
    toggleSlide(slideWrap, event) {
      if (this.$refs[slideWrap].offsetHeight === 42) {
        this.$refs[slideWrap].style.height = "auto";
        event.target.innerHTML = "收起筛选项";
      } else {
        this.$refs[slideWrap].style.height = "42px";
        event.target.innerHTML = "展开筛选项";
      }
    },
    // 导出筛选结果
    exportResult() {
      let params = {
        employeeName: this.param.employeeName,
        documentNumber: this.param.documentNumber,
        phone: this.param.phone,
        personType: this.param.personType,
        quitCrmStatus: this.param.quitCrmStatus,
        isAuthentivayion: this.param.isAuthentivayion,
        contractTypeId: this.param.contractTypeId,
        qiyuesuoAccountId: this.param.qiyuesuoAccountId,
        clientID: this.param.clientId,
        zhangtaoId: this.param.zhangtaoId,
        pensionClassCityId: this.param.pensionClassCityId,
        empPk: this.param.empPk,
        pageSize: 0,
        pageNo: 0,
      };
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmQhrInfoRest/export",
        data: params,
      })
        .then((res) => {
          if (res.data && res.data.status == 200) {
            this.listLoading = false;
            // console.log(res);
            // console.log(utils.returnUrlHead() + res.data.message);
            location.href = utils.returnUrlHead() + res.data.message;
            // this.$alert(res.data.message);
          } else {
            this.listLoading = false;
            this.$alert(res.data.message);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
    },
    //翻页
    handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.Information = false;
      this.getData();
    },
    //确认离职 取消离职
    handleQuitCrmStatus(item, type) {
      let title;
      if (type == 4) {
        title = "确认离职?";
      }
      if (type == 3) {
        title = "取消离职?";
      }
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: item.id,
          quitCrmStatus: type,
        };
        this.$http({
          method: "POST",
          url: "/rest/CrmQhrInfoRest/qhrlongPromotionQuit",
          params: params,
        })
          .then((res) => {
            console.log(res.data);
            if (res.data && res.data.status == 200) {
              this.listLoading = false;
              this.getData();
            } else {
              this.listLoading = false;
              this.$alert(res.data.message);
            }
          })
          .catch((error) => {
            this.listLoading = false;
            this.$alert("修改状态失败，请联系管理员！");
          });
      });
    },
    //跳转详情
    handleDetails(item) {
      this.itemId = item.id;
      this.Information = true;
    },
    searchContract(){
      this.$refs.contractQys.dialogVisible = true;
       this.$refs.contractQys.getList();
        this.$refs.contractQys.listLoading = true;
    }
  },
};
</script>

<style scoped>
.cutLine {
  border-right: 1px solid #82bc82;
  margin: 0 10px;
  position: relative;
  right: 1px;
}

.tableBody {
  background-color: white;
  margin-top: 15px;
  padding: 20px;
}

.title {
  color: #2e2b78;
  margin-bottom: 20px;
  font-weight: 900;
}
</style>
<style  >
.Qhr_contract .el-dialog__header {
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/views/personnelCenter/QHRPersonnel.vue